import { HttpService } from '@/services/http.service';

export default {
    async store(surveyResponse) {
        return await HttpService.httpPost('/survey-responses/store', surveyResponse);
    },
}
